module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAABFklEQVQokY2SvyuGURTHP97ebEyyGi1KETYjymAwmtTXKBn8+gsMyij1nDJIFiGbTSmTiYXVwmAiFunRebr37bx6vPlu9/vjnHPPvV1lWZJhZkvAAjAENIB74FjSfva0AmZ2DsxRj0tJM6Qqbj7qYHZMm9lJ1aEoilHgNohvwC7wBawA/THYBNYC8QmMS3pMnQ+AO6Av6Rs+0kQInGWzQ9Kz54I+6IHuQPTWzB+5pgdeAjFrZmP5YGbDwGLQP/wOF8BIIrzAjZntAd/AslcNgWvfUg/w+mu0vzDQkPTu6/qHeV7SU/Vwkq6c6GBel3SaZ66QiNUa86GknXxo+3xpM9vAZr6kpMmotzqETlv+Q4EHYKpNBH4AlhxTSDi0LZMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/w1.png
// module id = EGaC
// module chunks = 42